import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import Loader from './Loader';
import Sidebar from './Sidebar';
import { toast } from 'react-toastify';
import { firestore } from '../firebase.config';
import {
    collection,
    getDocs,
    deleteDoc,
    doc,
    addDoc,
    updateDoc, // 🆕
} from 'firebase/firestore';
import { Trash2, Edit2 } from 'lucide-react'; // 🆕 Edit2

const FIELD_OPTIONS = ['Gaushala', 'Education', 'Hunger', 'Occasion'];

const AddCategory = () => {
    const [selectedField, setSelectedField] = useState('');
    const [name, setName] = useState('');
    const [raised, setRaised] = useState('');
    const [donor, setDonor] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [field, setField] = useState(false);
    const [alertStatus, setAlertStatus] = useState('danger');
    const [msg, setMsg] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [editId, setEditId] = useState(null); // 🆕 Track which item is being edited
    const [recentImageUrl, setRecentImageUrl] = useState('');
    const [recentUploadProgress, setRecentUploadProgress] = useState(0);
const formRef = useRef(null);

    const cloudName = "dabhatz7m";
    const uploadPreset = "ImageUpload";

    const [uploadedPhotoUrl, setUploadedPhotoUrl] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);

    const toggleSidebar = (state) => {
        setIsSidebarOpen(state);
    };
    const handleRecentPhotoUpload = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) return alert("Please select an image!");

        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", uploadPreset);
        formData.append("folder", "RecentOccasion");

        const xhr = new XMLHttpRequest();
        xhr.open("POST", `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, true);

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percent = (event.loaded / event.total) * 100;
                setRecentUploadProgress(percent);
            }
        };

        xhr.onload = () => {
            if (xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                setRecentImageUrl(data.secure_url);
                setRecentUploadProgress(0);
            } else {
                console.error("Upload failed");
                setRecentUploadProgress(0);
            }
        };

        xhr.send(formData);
    };

    const handlePhotoUpload = (e) => {
        e.preventDefault();
        const file = document.getElementById("photoInput").files[0];
        if (!file) return alert("Please select an image!");

        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", uploadPreset);
        formData.append('folder', 'CategoryPhoto');

        const xhr = new XMLHttpRequest();
        xhr.open("POST", `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, true);

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100;
                setUploadProgress(percentComplete);
            }
        };

        xhr.onload = () => {
            if (xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                if (!data.secure_url) {
                    console.error("Secure URL is missing from Cloudinary response");
                    return;
                }
                setUploadedPhotoUrl(data.secure_url);
                setUploadProgress(0);
            } else {
                console.error("Failed to upload image to Cloudinary");
                setUploadProgress(0);
            }
        };

        xhr.onerror = () => {
            console.error("Error uploading image:", xhr.statusText);
            setUploadProgress(0);
        };

        xhr.send(formData);
    };

    const saveCategory = async () => {
        setIsLoading(true);

        // Validation
         if (!selectedField || !name){
            setField(true);
            setMsg("Required fields can't be empty");
            setAlertStatus("danger");
            toast.error("Required fields can't be empty");
            setIsLoading(false);
            setTimeout(() => setField(false), 4000);
            return;
        }

        if (!uploadedPhotoUrl) {
            setField(true);
            setMsg("Please upload a category photo.");
            setAlertStatus("danger");
            toast.error("Please upload a category photo.");
            setIsLoading(false);
            setTimeout(() => setField(false), 4000);
            return;
        }

    

        try {
            if (editId) {
                // ✅ UPDATE
                await updateDoc(doc(firestore, 'Category', editId), {
                    selectedField,
                    name,
                    photoUrl: uploadedPhotoUrl,
                    donor: donor || "",
                    recentOccasionImage: recentImageUrl || "",
                });

                toast.success("Category updated successfully");

            } else {
                // ✅ CREATE
                const id = `${Date.now()}`;

                const data = {
                    id,
                    selectedField,
                    name,
                    photoUrl: uploadedPhotoUrl,
                   donor: donor || "", 
                   recentOccasionImage: recentImageUrl || "", 
                };

                await addDoc(collection(firestore, 'Category'), data);

                toast.success("Category saved successfully");
            }

            // Reset + refresh
            clearData();
            fetchCategories();
            setField(true);
            setMsg(editId ? "Category updated successfully" : "Category saved successfully");
            setAlertStatus("success");

            setTimeout(() => setField(false), 4000);

        } catch (error) {
            console.error("Error saving category:", error);
            toast.error("Failed to save category");
        }

        setIsLoading(false);
    };

    const clearData = () => {
        setRecentImageUrl('');
        setSelectedField('');
        setName('');
        setRaised('');
        setDonor('');
        setUploadedPhotoUrl('');
        setEditId(null); // 🆕 Reset edit state
    };

    const fetchCategories = async () => {
        try {
            const querySnapshot = await getDocs(collection(firestore, 'Category'));
            const categories = [];
            querySnapshot.forEach((docSnap) => {
                categories.push({ ...docSnap.data(), docId: docSnap.id });
            });
            setCategoryList(categories);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const handleDeleteCategory = async (docId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this category? This action cannot be undone.");
        if (!confirmDelete) return;

        try {
            await deleteDoc(doc(firestore, 'Category', docId));
            toast.success("Deleted successfully");
            fetchCategories();
        } catch (error) {
            console.error("Error deleting category:", error);
            toast.error("Failed to delete");
        }
    };

    // 🆕 Populate form with existing category data for editing
    const handleEditCategory = (item) => {
        setRecentImageUrl(item.recentOccasionImage || '');
        setSelectedField(item.selectedField);
        setName(item.name);
        setDonor(item.donor || '');
        setUploadedPhotoUrl(item.photoUrl || '');
        setEditId(item.docId);
        // Replace window.scrollTo with this:
    if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <div className='lg:flex h-screen bg-white'>
            <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <div className={`flex-1 p-1 lg:p-12 overflow-y-auto transition-all duration-300 lg:mt-2 mt-16 ${isSidebarOpen ? 'ml-56 p-0' : 'lg:ml-20 sm:ml-2'}`}>

                {/* Form Card */}
                <div ref={formRef}  className={`w-full max-w-4xl mx-auto bg-white shadow-xl rounded-2xl lg:p-8 ${isSidebarOpen ? 'p-1' : 'lg:p-8 p-8'}`}>
                    {/* 🆕 Dynamic heading */}
                    <h1 className={`lg:text-2xl font-bold text-[#fcaf17] mb-6 ${isSidebarOpen ? 'text-[13px]' : ''}`}>
                        {editId ? "Edit Category" : "Add Category"}
                    </h1>

                    {field && (
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className={`p-3 rounded-lg text-center text-lg font-medium mb-4 ${alertStatus === "danger" ? "bg-red-100 text-red-600" : "bg-green-100 text-green-600"}`}
                        >
                            {msg}
                        </motion.p>
                    )}

                    <div className='lg:space-y-4 space-y-2'>

                        {/* Select Field */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}>
                                Select Field
                            </label>
                            <select
                                value={selectedField}
                                onChange={(e) => setSelectedField(e.target.value)}
                                className={`w-full px-4 py-2 border border-gray-300 lg:text-md text-sm rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white ${isSidebarOpen ? 'text-xs' : ''}`}
                            >
                                <option value="">-- Select a Field --</option>
                                {FIELD_OPTIONS.map((opt) => (
                                    <option key={opt} value={opt}>{opt}</option>
                                ))}
                            </select>
                        </div>

                        {/* Name */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}>
                                Name
                            </label>
                            <input
                                type='text'
                                value={name}
                                autoComplete='off'
                                placeholder='Enter Name'
                                onChange={(e) => setName(e.target.value)}
                                className={`w-full px-4 py-2 border border-gray-300 lg:text-md text-sm rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:outline-none ${isSidebarOpen ? 'text-xs' : ''}`}
                            />
                        </div>

                        {/* Photo Upload */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}>
                                Photo
                            </label>
                            <label
                                htmlFor="photoInput"
                                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                            >
                                <svg
                                    className="mr-2 h-5 w-5 text-[#fcaf17]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <span>Upload Photo</span>
                            </label>
                            <input
                                type="file"
                                id="photoInput"
                                accept="image/*"
                                onChange={handlePhotoUpload}
                                className="hidden"
                            />

                            {/* Progress Bar */}
                            {uploadProgress > 0 && (
                                <div className="mt-2">
                                    <div className="bg-gray-200 rounded-full h-2.5 mb-1 dark:bg-gray-700">
                                        <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${uploadProgress}%` }}></div>
                                    </div>
                                    <p className="text-sm text-gray-600 text-center">{Math.round(uploadProgress)}%</p>
                                </div>
                            )}

                            {/* Preview */}
                            {uploadedPhotoUrl && (
                                <div className="relative mt-3 w-[200px] h-[130px] border rounded-md overflow-hidden">
                                    <img
                                        src={uploadedPhotoUrl}
                                        alt="Uploaded"
                                        className="w-full h-full object-cover"
                                    />
                                    <button
                                        onClick={() => setUploadedPhotoUrl('')}
                                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                                        title="Remove photo"
                                    >
                                        ✕
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* 🆕 Upcoming Occasion (was: Donor) */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}>
                                Recent Occasion
                            </label>
                            <input
                                type='text'
                                value={donor}
                                autoComplete='off'
                                placeholder='Enter Upcoming Occasion Name'
                                onChange={(e) => setDonor(e.target.value)}
                                className={`w-full px-4 py-2 border border-gray-300 lg:text-md text-sm rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:outline-none ${isSidebarOpen ? 'text-xs' : ''}`}
                            />
                        </div>
                        {/* Recent Occasion Image Upload */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}>
                                Recent Occasion Image
                            </label>

                            <label
                                htmlFor="recentPhotoInput"
                                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                            >
                                <svg
                                    className="mr-2 h-5 w-5 text-[#fcaf17]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <span>Upload Photo</span>
                            </label>

                            <input
                                type="file"
                                id="recentPhotoInput"
                                accept="image/*"
                                onChange={handleRecentPhotoUpload}
                                className="hidden"
                            />

                            {/* Progress Bar */}
                            {recentUploadProgress > 0 && (
                                <div className="mt-2">
                                    <div className="bg-gray-200 rounded-full h-2.5 mb-1">
                                        <div
                                            className="bg-blue-600 h-2.5 rounded-full"
                                            style={{ width: `${recentUploadProgress}%` }}
                                        ></div>
                                    </div>
                                    <p className="text-sm text-gray-600 text-center">
                                        {Math.round(recentUploadProgress)}%
                                    </p>
                                </div>
                            )}

                            {/* Preview */}
                            {recentImageUrl && (
                                <div className="relative mt-3 w-[200px] h-[130px] border rounded-md overflow-hidden">
                                    <img
                                        src={recentImageUrl}
                                        alt="Recent Occasion"
                                        className="w-full h-full object-cover"
                                    />
                                    <button
                                        onClick={() => setRecentImageUrl('')}
                                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                                        title="Remove photo"
                                    >
                                        ✕
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* 🆕 Save / Update + Cancel Buttons */}
                        <div className="flex justify-start pt-2 gap-3">
                            <button
                                className="bg-blue-600 text-white lg:text-sm text-xs py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
                                onClick={saveCategory}
                            >
                                {isLoading ? <Loader /> : editId ? 'Update' : 'Save'}
                            </button>
                            {editId && (
                                <button
                                    className="bg-gray-200 text-gray-700 lg:text-sm text-xs py-2 px-4 rounded-lg hover:bg-gray-300 transition duration-300"
                                    onClick={clearData}
                                >
                                    Cancel
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Table Section */}
                {categoryList.length > 0 ? (
                    <div className="mt-12 p-8 transform transition-all duration-300 hover:shadow-yellow-300/40">
                        <h2 className="text-3xl font-extrabold mb-8 text-[#fcaf17] tracking-wide flex items-center gap-3 animate-fade-in-down">
                            <span>✨</span> Category Collection
                        </h2>

                        <div className="overflow-hidden border border-yellow-200 transform transition-all duration-300 hover:shadow-yellow-200/20 overflow-x-auto">
                            <table className="min-w-full text-sm text-left text-gray-700">
                                <thead className="bg-gradient-to-r from-yellow-100 to-yellow-200/70 backdrop-blur-sm border-b border-yellow-300 text-[14px] uppercase font-bold tracking-wider text-orange-800 animate-slide-in-top">
                                    <tr>
                                        <th className="px-6 py-4">Sl. No.</th>
                                        <th className="px-6 py-4">Field</th>
                                        <th className="px-6 py-4">Name</th>
                                        <th className="px-6 py-4">Photo</th>
                                        {/* 🆕 Column header renamed */}
                                        <th className="px-6 py-4">Recent Occasion</th>
                                        <th className="px-6 py-4">Photo</th>
                                        <th className="px-6 py-4 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categoryList.map((item, index) => (
                                        <tr
                                            key={item.docId}
                                            className="group bg-white/70 transition-all duration-300 hover:bg-orange-50/70 border-b border-orange-100 last:border-b-0 animate-fade-in"
                                        >
                                            <td className="px-6 py-4 font-semibold text-gray-800 text-base">{index + 1}</td>
                                            <td className="px-6 py-4">
                                                <span className="inline-block bg-yellow-100 text-yellow-800 text-xs font-semibold px-3 py-1 rounded-full">
                                                    {item.selectedField}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 text-gray-900 font-medium">{item.name}</td>
                                            <td className="px-6 py-4">
                                                <img
                                                    src={item.photoUrl}
                                                    alt={item.name}
                                                    className="w-28 h-20 object-cover rounded-xl border-2 border-gray-200 shadow-md group-hover:scale-105 group-hover:border-orange-400 transition-all duration-300 ease-in-out cursor-pointer"
                                                />
                                            </td>
                                            <td className="px-6 py-4 text-gray-600">{item.donor || "No Occasion"}</td>
                                            <td className="px-6 py-4">
                                                {item.recentOccasionImage ? (
                                                    <img
                                                        src={item.recentOccasionImage}
                                                        alt="Recent Occasion"
                                                        className="w-28 h-20 object-cover rounded-xl border-2 border-gray-200 shadow-md hover:scale-105 hover:border-orange-400 transition-all duration-300 cursor-pointer"
                                                    />
                                                ) : (
                                                    <span className="text-gray-400 text-sm italic">No Image</span>
                                                )}
                                            </td>
                                            {/* 🆕 Actions with Edit + Remove */}
                                            <td className="px-6 py-4 text-center">
                                                <div className="flex justify-center gap-2">
                                                    <button
                                                        onClick={() => handleEditCategory(item)}
                                                        className="inline-flex items-center gap-2 text-blue-600 hover:text-white bg-blue-100 hover:bg-blue-500 px-4 py-2 rounded-full text-sm font-semibold shadow-md transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2"
                                                        title="Edit Category"
                                                    >
                                                        <Edit2 className="w-4 h-4" />
                                                        Edit
                                                    </button>
                                                    <button
                                                        onClick={() => handleDeleteCategory(item.docId)}
                                                        className="inline-flex items-center gap-2 text-red-600 hover:text-white bg-red-100 hover:bg-red-500 px-4 py-2 rounded-full text-sm font-semibold shadow-md transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-300 focus:ring-offset-2"
                                                        title="Remove Category"
                                                    >
                                                        <Trash2 className="w-4 h-4" />
                                                        Remove
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="mt-12 p-8 text-center text-gray-500 text-lg italic bg-white border border-orange-100 rounded-xl shadow-sm">
                        No categories added yet. Let's create one!
                    </div>
                )}

                <style jsx>{`
                    @keyframes fade-in-down {
                        from { opacity: 0; transform: translateY(-20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes slide-in-top {
                        from { opacity: 0; transform: translateY(-10px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes fade-in {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    .animate-fade-in-down { animation: fade-in-down 0.8s ease-out forwards; }
                    .animate-slide-in-top { animation: slide-in-top 0.6s ease-out forwards; }
                    .animate-fade-in { animation: fade-in 0.5s ease-out forwards; }
                `}</style>
            </div>
        </div>
    );
};

export default AddCategory;